<template>
<div class="industry" :class="{showDetail:$route.path !== '/news/company'}">
    <div v-show="$route.path == '/news/industry'">
        <h1 class="title">技术动态</h1>
        <p class="sub-title">TECHNOLOGY TRENDS</p>
        <div class="wrap">
            <div class="news" v-for="(item, index) in datas.data" :key="index" :style="{marginRight:(index+1)%3 == 0?'0':'20px'}" @click="$router.push({path:'/news/industry/detail',query:{id:item.id}})">
                <img :src="item.image" alt srcset />
                <div>
                    <p class="name">{{spliceText(item.name,30)}}</p>
                    <p class="date">{{item.date}}</p>
                    <p class="desc">{{spliceText(item.summary,45)}}</p>
                </div>
            </div>
        </div>
        <el-pagination :page-size="6" background prev-text="上一页 " next-text="下一页" layout="prev, pager, next" :total="datas.total" @current-change="change"></el-pagination>
    </div>
    <router-view></router-view>
</div>
</template>

<script>
import {
    article
} from "../../assets/js/api";
export default {
    data() {
        return {
            datas: {},
            page: 1,
        };
    },
    created() {
        if (this.$route.query.id) {
            setTimeout(() => {
                this.$router.push({
                    path: "/news/company/detail",
                });
            }, 100);
        } else {
            this.getData();
        }
    },
    methods: {
        change(e) {
            this.page = e;
            this.getData();
        },
        getData() {
            article({
                limit: 6,
                page: this.page,
                where: {
                    type: 2,
                },
            }).then((r) => {
                this.datas = r.data;
            });
        },
    },
};
</script>

<style lang="less" scoped>
.industry {
    padding: 90px 0;

}

.industry.showDetail {
    background-color: #f3f2f2;
}

h1.title {
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: rgba(0, 0, 0, 1);
    text-align: center;
}

p.sub-title {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: rgba(204, 204, 204, 1);
    text-align: center;
}

.wrap {
    display: flex;
    flex-wrap: wrap;
    width: 1200px;
    margin: 0 auto;
    margin-top: 60px;
    margin-bottom: 60px;

    .news {
        margin-bottom: 20px;
        width: 386px;
        box-sizing: border-box;
        cursor: pointer;

        img {
            width: 100%;
            height: 340px;
            vertical-align: middle;
        }

        &>div {
            padding: 29px 27px;
            box-sizing: border-box;
            background: #f8f8f8;
            width: 100%;
            height: 222px;
            transition: all 0.15s linear;

            &>* {
                transition: all 0.15s linear;
            }

            .name {
                font-size: 18px;
                font-family: Source Han Sans CN;
                font-weight: bold;
                color: rgba(0, 0, 0, 1);
                word-break: break-all;
            }

            .date {
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: rgba(0, 0, 0, 1);
                margin-top: 19px;
                margin-bottom: 28px;
            }

            .desc {
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: rgba(0, 0, 0, 1);
                word-break: break-all;
            }
        }
    }

    .news:hover {
        &>div {
            background: #0e6cb6;

            .name,
            .date,
            .desc {
                color: white;
            }
        }
    }
}
</style>
